import {Component, Inject, OnInit, ViewChild, OnChanges} from '@angular/core';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {ConfService} from '../../conf.service';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {FormControl} from '@angular/forms';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
const incr = 7;
declare let $;
interface KeyValuePair {
  key: string;
  value: string;
  description: string;
}
export interface ICategory {
  name: string;
}
@Component({
  selector: 'app-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss']
})
export class ViewerComponent implements OnInit {

  isAdmin: boolean;

  API_creators = [
    {
      card_title: "DataAccess API",
      card_content: "Provides you with API endpoints to access data in your database",
      bg:"#50c878",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Query Builder API",
      card_content:"Enables users to create API using standard SQL queries",
      bg:"#ff8a2d",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Business Logic API",
      card_content:"Drag and drop blocks to generate executable code",
      bg:"#9e774c",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"WorkFlow  API",
      card_content:"Enables to visualise and launch your workflow automations",
      bg:"#2a9df4",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Email Template Builder API",
      card_content:"Build Email Templates with drag and drops and embed this API into the product",
      bg:"#b19cd9",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"DMN",
      card_content:"Enables users to create a graphical description for business decisions",
      bg:"#b3ba77",
      routeto:"https://devex.services.apiplatform.io//"
    }
  ];
  Business_enablers = [
    {
      card_title:"Database to API",
      card_content:"Enables users to convert the database table into an API",
      bg:"#d65f59",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Open API spec to API",
      card_content:"Provides you with an API from an existing Open API Spec(OAS) ",
      bg:"#77b5fe",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Data API to API",
      card_content:"Enables users to convert the Data API into an API ",
      bg:"#a7e074",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"SOAP to API",
      card_content:"Enables users to create an API from the SOAP based API endpoints",
      bg:"#b3ba77",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"JSON to API",
      card_content:"Enables users to convert the JSON data structure into an API",
      bg:"#50c878",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Subscribers Management",
      card_content:"Enables users to provision and manage subscriber access in a multiplayer network",
      bg:"#2a9df4",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Logging and Monitoring",
      card_content:"Enables users to monitor logging across various devices",
      bg:"#ff9c2d",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Cost Manager",
      card_content:"Enables users to manage their expenses and keep track of it",
      bg:"#b19cd9",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Campaign Manager",
      card_content:"Helps you to manage your digital campaigns across websites",
      bg:"#c7739d",
      "routeto":"https://devex.services.apiplatform.io//"
    }
  ];
  Tools_and_Settings = [
    {
      card_title:"File Manager",
      card_content:"Provides users a storage to manage their files in the cloud",
      bg:"#50c878",
      "routeto":"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Access Control Management",
      card_content:"Enables users to control the access to APIs and manage it",
      bg:"#b19cd9",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Account Manager",
      card_content:"Provides users to manage to their account details",
      bg:"#2a9df4",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Database Manager",
      card_content:"Enables users to manage the databases used to create APIs",
      bg:"#ff7878",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"IP Whitelist Settings",
      card_content:"Enables users to provide access only to Whitelisted IP users",
      bg:"#9e774c",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Email Settings",
      card_content:"Enables users to manage their account email details",
      bg:"#ff8a2d",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Billing & Credits",
      card_content:"Enables users to produce bill and also to apply coupons",
      bg:"#a7e074",
      routeto:"https://devex.services.apiplatform.io//"
    },
  ];

  Integrations = [
    {
      card_title:"Slack",
      card_img:"./assets/logo/slack_logo.png",
      bg:"#1c1c1c",
      routeto:"https://devex.services.apiplatform.io//"
    },
    {
      card_title:"Jira",
      card_img:"./assets/logo/jira_logo.png",
      bg:"#2a9df4",
      routeto:"https://devex.services.apiplatform.io//"
    }
  ];

  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');
  initialWindow = true;
  initialItems: any;
  entity: string;
  version: string;
  language: string;
  URL: string;
  typ: string;
  partnerKey: any;
  showCategories = false;
  gotPartnerKey = false;
  items: any;
  attributes: any;
  operations: any;
  params: any;
  error = false;
  errorMessage: string;
  response: any;
  getResponse: any;
  getRequest: any;
  getHttpOptions: any;
  putResponse: any;
  putRequest: any;
  putHttpOptions: any;
  dataModelPost: any;
  dataModelPut: any;
  postResponse: any;
  postRequest: any;
  postHttpOptions: any;
  dataModel: any;
  dataSource: any;
  deleteResponse: any;
  deleteRequest: any;
  deleteHttpOptions: any;
  parametersHeaders = ['key', 'value', 'description'];
  parameterData = [];
  // pathParameter = [];
  headersData = [];
  formData = [];
  // description_flag: boolean;
  requestBodySelected = 'none';
  requestBodyTypes = [
    {'displayName': 'None', 'value': 'none'},
    {'displayName': 'Form Data', 'value': 'form-data'},
    {'displayName': 'Form URL Encoded', 'value': 'x-www-form-urlencoded'},
    {'displayName': 'Raw', 'value': 'raw'},
    {'displayName': 'Binary / File', 'value': 'binary'}

  ];
  httpOperation = 'GET';
  httpOperations = [
    {'name': 'GET'},
    {'name': 'POST'},
    {'name': 'PUT'},
    {'name': 'PATCH'},
    {'name': 'DELETE'},
    {'name': 'COPY'},
    {'name': 'HEAD'},
    {'name': 'OPTIONS'},
    {'name': 'LINK'},
    {'name': 'UNLINK'},
    {'name': 'LOCK'},
    {'name': 'UNLOCK'},
    {'name': 'PROPFIND'},
    {'name': 'PURGE'},
    {'name': 'VIEW'}
  ];
  httpUrl: string;
  execute: boolean;
  save: boolean;
  rawRequestBody: any;
  responseBody: any;
  devexgeneric = false;

  languages: any;
  languageSelected = 'en';
  columns: string[] = [];
  navigate: any;
  searchText: any;
  itemLength: any;
  filterData: any[];
  itemList: any[];
  options: any;
  userView = 'json';
  settings = {text: 'Select attribute(s) to search'};

  responseCookies: any;
  responseCode: any;
  responseData: any;
  responseItems: any;
  responses: any;
  responseObject: any;
  responseError: any;
  responseTimestamp: any;
  responseHeaders: any;
  responseTime: any;
  myControl = new FormControl();
  executorName: string;
  executorVersion: string;
  queryParams: any;
  headers: any;
  authModel: any;
  requestBody: any;
  prerequisites: any;
  // showProgress = false;
  showNextPanel = false;
  progress = 0;
  progressMessage: string;
  url = environment.apihost;
  apiKey = localStorage.getItem('apikey');

  businesslogic = false;
  dataaccess = false;
  executor_name: any;
  executor: any;
  executor_version: any;
  document: any;
  platformdocs = false;
  @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
  options1 = new JsonEditorOptions();
  filteredOptions: Observable<ICategory[]>;

  data: any;
  executors: any;
  executorscat: any;
  index = [];
  executorscat1: any;
  category_id: any;

  constructor(private _service: ConnecttocrudService, private confPost: ConfService,
              private location: Location,
              private route: ActivatedRoute,
              public snackBar: MatSnackBar,
              private router: Router,
              private Urlroute: ActivatedRoute,
              public dialog: MatDialog,
              public platform: LeftpanelComponent) {
    this.options1.mode = 'code';
    this.options1.modes = ['code', 'text', 'tree', 'view'];
    this.options1.schema = '';
    this.options1.statusBar = false;
    this.options1.onChange = () => console.log(/* this.editor.get()*/);
  }

  async ngOnInit() {

    if (localStorage.getItem('partner') === 'services') {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    $('.menu li a').on('click', function() {
      $(this).addClass('active').siblings().removeClass('active');
    });

    if (localStorage.getItem('partner') && localStorage.getItem('account')) {
      await this.confPost.getPartnerKey(localStorage.getItem('partner')).toPromise().then( response => {
        localStorage.setItem('partnerKey', response['pkey']);
      });
    }

    this.route.queryParams
        .subscribe(params => {
          if (params.partner != null && params.account !== null) {
            this.partner = params.partner;
            this.account = params.account;
            this.businesslogic = false;
            if (params.entity != null && params.version) {
              this.businesslogic = false;
              // this.dataaccess = true;
              this.initialWindow = false;
              this.entity = params.entity;
              this.version = params.version;
              this.partnerKey = localStorage.getItem('partnerKey');
              this.items = null;
              this.getDevExItems();
              if (params.language != null) {
                this.language = params.language;
              } else {
                this.language = 'en';
              }
              // this.confPost.getCategoriesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
              //   this.options = data;
              //   this.filteredOptions = this.myControl.valueChanges
              //       .pipe(
              //           startWith<string | ICategory>(''),
              //           map(value => typeof value === 'string' ? value : value.name),
              //           map(name => name ? this._filter(name) : this.options.slice())
              //       );
              // });

              // New Implementation but commented
              // if (this.platform.partnerCategories !== null && this.platform.partnerCategories !== undefined) {
              //   this.options = this.platform.partnerCategories;
              // } else {
              //   this.platform.getCategoriesForPartnerAccount();
              //   this.options = this.platform.partnerCategories;
              // }
              // this.filteredOptions = this.myControl.valueChanges
              //     .pipe(
              //         startWith<string | ICategory>(''),
              //         map(value => typeof value === 'string' ? value : value.name),
              //         map(name => name ? this._filter(name) : this.options.slice())
              //     );

            } else if (params.executor_name !== null && params.executor_version !== null) {
              this.businesslogic = true;
              this.executor_name = params.executor_name;
              this.executor_version = params.executor_version;
              this.confPost.getApiExecutorByPartnerAccountEntityVersion(this.partner, this.account, this.executor_name, this.executor_version).subscribe(data => {
                this.executor = data;
                this.initialWindow = false;
                // this.businesslogic = true;
              });
            }
            this.devexgeneric = false;
            // this.pathParameter = this.executor.pathParams;
          } else {
            this.partner = 'services';
            this.account = 'services';
            this.document = params.document;
            this.platformdocs = true;
            this.confPost.getData('services', 'services', 'v1', 'serviceCategories', null).subscribe(response => {
              this.data = response;
              for ( let i = 0; i < this.data.length; i++) {
                if (this.data[i].id === parseInt(this.document, 10)) {
                  this.items = this.data[i];
                }
              }
              this.confPost.getBusinessLogicApisByCategory('services', 'services').subscribe(data => {
                this.executors = data;
                this.executorscat = [];
                for (let i = 0 ; i < this.executors.length; i++) {
                  if (this.executors[i].category === this.items.name) {
                    this.executorscat.push(this.executors[i].executors);
                  }
                }
                this.executorscat1 = [];
                this.executorscat1 = JSON.parse(JSON.stringify(this.executorscat));
                let temp = [];
                let flag: boolean;
                for (let k = 0; k < this.executorscat[0].length; k++) {
                  flag = false;
                  for (let i = 0; i < this.items.apisList.length; i++) {
                    if (this.executorscat[0][k].id === this.items.apisList[i]) {
                      flag = true;
                    }
                  }
                  if (flag === false) {
                    temp.push(this.executorscat[0][k]);
                  }
                }
                this.executorscat[0] = temp;
                // localStorage.setItem('businessLogicAPI' , JSON.stringify(this.executors));
              });
            });

          }

        });
  }

  getDataModel() {
    this.dataModel = {};
    const that = this;
    this.dataSource.forEach((data) => {
      if (data.type !== 'Array') {
        this.dataModel[data.attributeName] = data.type;
      } else {
        this.dataModel[data.attributeName] = (that.getSub(data.subType).length > 0 ? that.getSub(data.subType) : []);
      }
    });

    this.dataModelPut = this.dataModel;
    this.dataModelPost = this.dataModel;
    return this.dataModel;
  }
  private _filter(name: string): ICategory[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }

  getVersionofEntity(val) {
    /* var str = Object.values(val).toString();
     return str.substr(str.indexOf('.') + 1, str.length);*/
    const data = val.split('#');
    return data[1];
  }
  saveApi() {
  }
  getEntity(val) {
    const data = val.split('#');
    /* var str = Object.values(val).toString();
     return str.substr(0, str.indexOf('.')).toString();*/
    return data[0];
  }

  getBackgroundStyle(val) {
    if (val === 'GET') {
      return 'get-method';
    } else if (val === 'PUT') {
      return 'put-method';
    } else if (val === 'POST') {
      return 'post-method';
    } else if (val === 'DELETE') {
      return 'delete-method';
    } else {
      return 'get-method';
    }
  }
  getStatusCodeStyle(val) {
    if (val < 400) {
      return 'status-ok';
    } else {
      return 'status-not-ok';
    }
  }
  deleteRecord(version, id: string, event) {
    if (confirm('This action is irreversible, Are you sure you want to delete this record?')) {
      this._service.deleteItem(id, version, this.partner, this.account, this.entity).subscribe(
          agents => {
            this.platform.openSnackBar('Deleted the record successfully', 'Success', {
              duration: 2000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            const itemDuplicate = this.items;
            const deleteditem =  itemDuplicate.findIndex(p => p.id === id);
            delete this.items[deleteditem];
            //  this.removeItemFromUI(event);
          },
          error => {
            this.platform.openSnackBar('Error while deleting this record' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          }
      );
    } else {
    }
  }
  removeItemFromUI(event) {
    $(event.target).closest('td').parent('tr').remove();
  }
  typeOfval(val) {
    return typeof val;
  }
  getSub(data) {
    const subType = [];
    const obj = {};
    const that = this;
    if (data.length > 0) {
      data.forEach((result) => {
        if (result.type != 'Array') {
          obj[result.attributeName] = result.type;
        } else {
          obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
        }
      });
      subType.push(obj);
    }
    return subType;
  }
  manageProgress() {
    if (this.progress >= 100) {
      this.save = false;
      this.showNextPanel = true;
    } else {
      this.progress = this.progress + incr;
    }
    if (this.progress <= 35) {
      this.progressMessage = 'Setting Up Business Logic API';
    } else if (this.progress > 35 && this.progress <= 70) {
      this.progressMessage = 'Setting Up Database';
      /*} else if (this.progress > 70 && this.progress <= 98) {
          this.progressMessage = 'Creating dedicated File storage for your account';*/
    } else if (this.progress > 70) {
      this.progressMessage = 'Deploying into Cloud';
    }
  }

  download() {
    $('.actions-crud').find('a:eq(2)').find('angular2csv').find('button').click();
  }

  addParameter() {
    const pushData = {
      'key': '',
      'value': '',
      'description': ''
    };
    this.parameterData.push(pushData);
  }
  removeParameter(index) {
    delete this.parameterData[index];
  }

  addHeader() {
    const pushData = {
      'key': '',
      'value': '',
      'description': ''
    };
    this.headersData.push(pushData);
  }

  removeHeader(index) {
    delete this.headersData[index];
  }
  addFormData() {
    const pushData = {
      'key': '',
      'value': '',
      'description': ''
    };
    this.formData.push(pushData);
  }
  removeFormData(index) {
    delete this.formData[index];
  }

  getDevExItems() {
    this.confPost.getPartnerEntity(this.account, this.entity, this.partner).subscribe(items => {
      this.dataSource = items[0].attributes;
      this.getDataModel();
    });
    this.error = false;
    this.confPost.getEntity(this.partner, this.account, this.entity, this.version).subscribe(
        items => {
          this.items = items;
          this.attributes = this.items.attributes;
          // this.operations = this.items.operations;
          this.getRequest = null;
          // this.dataaccess = true;
          this.businesslogic = false;
          this.getResponse = null;
          this.putRequest = null;
          this.putResponse = null;
          this.postRequest = null;
          this.postResponse = null;
          this.deleteRequest = null;
          this.deleteResponse = null;

          this.confPost.getApiExecutorsByPartnerAccountEntityVersion(this.partner, this.account, this.entity, this.version).subscribe(
              executors => {
                this.operations = executors;
              });
        },
        error => { this.error = true;
        this.errorMessage = (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : ''; }
    );
  }
  stringifyjson(val) {
    if (val != null) {
      return JSON.stringify(val, null, 2).trim();
    } else {
      return val;
    }
  }
  print(val) {
    if (val != null) {
      return val.trim();
    }
    return val;
  }
  getParameterTableName(val) {
    if (val != null && val.length === 0) {
      return val.toLowerCase() + 'OperationTable';
    }
    return 'OperationTable';
  }
  getHeaderTableName(val) {
    if (val != null && val.length === 0) {
      return val.toLowerCase() + 'HeaderTable';
    }
    return 'HeaderTable';
  }

  getRequestBody() {
    const requestbody = {
      'type': this.requestBodySelected,
      'value': this.getRequestBodyValue(this.requestBodySelected)
    };
    return requestbody;
  }
  getRequestBodyValue(val) {
    switch (val) {
      case 'raw':
        return this.editor.get();

      case 'binary':
      case 'none':
      default:
    }
  }

  executeApi() {
    this.responseData = '';
    this.errorMessage = '';
    this.responseError = '';
    // const parameters = {};
    // $('#parametersTable').children('tbody').children('tr').each(function () {
    //     parameters[$(this).find('td:first').find('input').val()] = $(this).find('td:eq(1)').find('input').val();
    // });
    //
    // const headers = {};
    // $('#headersTable').children('tbody').children('tr').each(function () {
    //     headers[$(this).find('td:first').find('input').val()] = $(this).find('td:eq(1)').find('input').val();
    // });

    const payload = {
      'executor_name': '',
      'executor_type': 'API',
      'executor_method_type': this.httpOperation,
      'apiUrl': this.httpUrl,
      'dataroot': null,
      'queryParams': this.parameterData,
      // 'pathParams': this.pathParameter,
      'headers': this.headersData,
      'authModel': null,
      'requestBody': this.getRequestBody(),
      'prerequisites': null
    };
    this._service.executeApi(payload).subscribe(response => {
          this.responses = response;
          this.responseItems = this.responses.body;
          this.responseCode = this.responseItems.statusCode;
          if (this.responseCode >= 400) {
            this.error = true;
          } else {
            this.error = false;
          }
          if (this.error) {
            if (this.responseItems.body) {
              this.responseData = JSON.parse(this.responseItems.body);
              this.errorMessage = this.responseData.message;
              this.responseError = this.responseData.error;
            } else {
              this.errorMessage = this.responseItems.message;
              if (this.responseItems.error) {
                this.responseError = this.responseItems.error;
              }
            }
          }
          this.responseHeaders = this.responseItems.headers;
          if (this.responseItems.body) {
            this.responseData = JSON.parse(this.responseItems.body);
          }
          this.responseTime = this.responseItems.timeInMillis;
        },
        error => {
          if (error.error.message) {
            // Need to revisit this part later
            if (error.error.message.substring(error.error.message.lastIndexOf('{'), error.error.message.indexOf('}') + 1)) {
              this.responseObject = JSON.parse(error.error.message.substring(error.error.message.lastIndexOf('{'), error.error.message.indexOf('}') + 1));
              this.responseCode = this.responseObject.status;
              this.errorMessage = this.responseObject.message;
              this.responseError = this.responseObject.error;
              this.responseTimestamp = this.responseObject.timestamp;
            } else {
              this.responseCode = error.error.status;
              this.errorMessage = error.error.message;
              this.responseError = 'Internal Server Error';
            }
          } else {
            this.responseCode = 500;
            this.errorMessage = 'Error while processing your request. Please check the headers and query parameters that may be missing in your request.';
            this.responseError = 'Internal Server Error';
          }
          this.error = true;
        }
    );
  }

  TestEndpoints(type, url, pkey) {

    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'pkey': pkey,
        'Access-Control-Allow-Origin': '*'
      })
    };

    if (type === 'GET') {
      this.getHttpOptions = httpOptions1;
      if ($('#GETdatabase').val() != null && $('#GETdatabase').val().length !== 0 && $('#GETquery').val() != null && $('#GETquery').val().length !== 0) {
        url += '?' + 'database=' + $('#GETdatabase').val() + '&' + 'query=' + $('#GETquery').val();
      } else {
        if ($('#GETdatabase').val() != null && $('#GETdatabase').val().length !== 0) {
          url += '?' + 'database=' + $('#GETdatabase').val();
        }
        if ($('#GETquery').val() != null && $('#GETquery').val().length !== 0) {
          url += '?' + 'query=' + $('#GETquery').val();
        }
      }
      this.getRequest = environment.apihost + '/' + url;
      this._service.getItemsForUrl(url, this.getHttpOptions).subscribe(items => {
        this.getResponse = items;
      });
    } else if (type === 'PUT') {
      this.putHttpOptions = httpOptions1;
      const newUrl = url.replace(/:id/gi, $('#PUTid').val());
      this.putRequest = environment.apihost + '/' + newUrl;
      this._service.putItemForUrl(newUrl, this.putHttpOptions, this.dataModelPut).subscribe(items => {
        this.putResponse = items;
      });
    } else if (type === 'POST') {

      this.postHttpOptions = httpOptions1;
      this.postRequest = environment.apihost + '/' + url;
      const data = this.editor.get();
      data['id'] = this.dataSource.id;

      this._service.postItemForUrl(url, this.postHttpOptions, data).subscribe(items => {
        this.postResponse = items;
      });
    } else if (type === 'DELETE') {
      this.deleteHttpOptions = httpOptions1;
      const newUrl = url.replace(/:id/gi, $('#DELETEid').val());
      this.deleteRequest = environment.apihost + '/' + newUrl;
      this._service.deleteItemForUrl(newUrl, this.deleteHttpOptions).subscribe(items => {
        this.deleteResponse = items;
      });
    } else {

    }
  }
  getKey(val) {
    return Object.keys(val);
  }
  getData(one, two, three) {
    const data = {
      'type': one,
      'url': two,
      'pkey': three
    };
    return data;
  }

}
